/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React from 'react'
import { ShimmerBadge,
    ShimmerButton,
    ShimmerTitle,ShimmerThumbnail,ShimmerSectionHeader, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'

export default function SearchShimmer({ count = 4, height = '220px' }) {
    return (
        <div className="opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block" id="tabs-institutionDetails" role="tabpanel" aria-labelledby="tabs-institutionDetails-tab">
            <div className="w-1/2" style={{ height: height }}>
                {[...Array(count)].map((_, index) => (
                    <p key={index} className="text-2xl font-bold text-[#031624] mb-4">
                        <ShimmerTitle line={1} gap={10} variant="secondary" className="w-[150px]" />
                    </p>
                ))}
            </div>
        </div>
    );
}
